<template>
    <div>
        <products-table
            :is-loading="isLoading"
            :products-data="productsData"
            :height="height"
            :supplier-id="supplierId"
            :allow-import-csv="allowImportCsv"
            @change:search-products="searchProducts"
            @click:add-product="openProductModal"
            @click:edit-product="
                productClicked => openProductModal(productClicked)
            "
            @click:import-products="openImportProductsModal"
        ></products-table>
        <el-pagination
            :current-page.sync="currentPage"
            :total="totalProducts"
            :page-size.sync="limit"
            :page-sizes="[10, 25, 50]"
            class="pagination-footer"
            layout="prev, pager, next, sizes, ->, total"
        ></el-pagination>
        <product-modal
            v-if="showProductModal"
            :visible="showProductModal"
            :current-supplier-id="supplierId"
            :current-product="currentProduct"
            @close="closeProductModal"
            @save="saveProduct"
            @delete="deleteProduct"
        ></product-modal>
        <import-products-modal
            v-if="showImportProductsModal"
            :supplier-id="supplierId"
            :visible="false"
            @close="closeImportProductsModal"
            @upload:complete="getProducts"
        ></import-products-modal>
        <import-products
            v-if="showImportProductsModal"
            :visible="showImportProductsModal"
            :supplier-id="supplierId"
            @upload:complete="getProducts"
            @close="closeImportProductsModal"
        />
    </div>
</template>

<script>
import ImportProductsModal from "Components/ImportProductsModal";
import ImportProducts from "Components/ImportProducts";
import { ProductService } from "Services/ProductService";
import ImmutableCollectionMixin from "Mixins/ImmutableCollectionMixin";
import ProductsTable from "Components/ProductsTable";
import ProductModal from "Components/ProductModal";

export default {
    components: {
        ProductsTable,
        ProductModal,
        ImportProductsModal,
        ImportProducts,
    },
    mixins: [ImmutableCollectionMixin],
    props: {
        allowImportCsv: {
            type: Boolean,
            default: true,
        },
        supplierId: {
            type: String,
            default: "-",
        },
        height: {
            type: Number,
            required: false,
        },
    },
    data: () => ({
        showProductModal: false,
        currentProduct: {},
        search: "",
        searchTimer: null,
        productsData: [],
        isLoading: false,
        currentPage: 1,
        limit: 25,
        totalProducts: 0,
        showImportProductsModal: false,
    }),
    watch: {
        async currentPage(newVal, oldVal) {
            if (newVal !== oldVal) {
                this.getProducts();
            }
        },
        async limit(newVal, oldVal) {
            if (newVal !== oldVal) {
                this.getProducts();
            }
        },
    },
    async mounted() {
        this.getProducts();
    },
    methods: {
        openImportProductsModal() {
            this.showImportProductsModal = true;
        },
        closeImportProductsModal() {
            this.showImportProductsModal = false;
        },
        async getProducts() {
            this.isLoading = true;
            if (this.search.length < 3) {
                const getAllProductsResponse = await ProductService.getBySupplier(
                    this.supplierId,
                    this.limit,
                    this.currentPage - 1
                );
                this.productsData = getAllProductsResponse.data;
                this.totalProducts = getAllProductsResponse.total;
            } else {
                const searchProductsResponse = await ProductService.searchBySupplier(
                    this.supplierId,
                    this.search,
                    this.limit,
                    this.currentPage - 1
                );
                this.productsData = searchProductsResponse.data;
                this.totalProducts = searchProductsResponse.total;
            }
            this.isLoading = false;
        },
        async saveProduct(product) {
            this.closeProductModal();

            if (product._id) {
                const updatedProduct = await ProductService.update(
                    product,
                    product.supplierId
                );
                this.productsData = this.$_immutableCollection_update(
                    this.productsData,
                    updatedProduct
                );
            } else {
                const newProduct = await ProductService.create(
                    product,
                    product.supplierId
                );
                this.productsData = this.$_immutableCollection_insert(
                    this.productsData,
                    newProduct
                );
            }
        },

        async deleteProduct(productIdToDelete) {
            this.isLoading = true;

            await ProductService.deleteById(productIdToDelete, "-");
            this.productsData = this.$_immutableCollection_deleteById(
                this.productsData,
                productIdToDelete
            );
            this.closeProductModal();

            this.isLoading = false;
            this.$message({
                type: "success",
                message: "Deleted Product",
            });
        },

        async searchProducts(search) {
            this.search = search;

            // Make sure we only search when user stops typing for 500ms
            clearTimeout(this.searchTimer);
            this.searchTimer = setTimeout(() => {
                this.getProducts();
            }, 500);
        },

        openProductModal(productClicked = {}) {
            this.currentProduct = productClicked;
            this.showProductModal = true;
        },

        closeProductModal() {
            this.showProductModal = false;
        },
    },
};
</script>

<style scoped lang="scss">
.create-product {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 30px;
}
</style>
